export default function stopEnterBubble(e){
    if(e.which === 13 && !(e.ctrlKey || e.altKey || e.metaKey) ){
        e.stopPropagation()
    }
}
